import { Accordion, Button, Link, MinusIcon, Text, View } from 'native-base';
import { IconButton } from '../Form/IconButton';
import { PencilIcon } from '../../icons/PencilIcon';
import React, { useMemo } from 'react';
import { format } from 'date-fns';
import { MEETING_TYPES_SELECT_OPTIONS } from './utils';

export const MeetingHeader = ({ isExpanded, item, onEdit, onRemove }) => {
  const meetingType = useMemo(
    () =>
      MEETING_TYPES_SELECT_OPTIONS.find(
        (opt) => opt.value === item?.meeting_type
      )?.label,
    [item.meeting_type]
  );

  const formattedDate = useMemo(() => {
    if (!item.meeting_date) {
      return !item.id ? 'New meeting' : '**** - ** - **';
    }

    const dateObj = new Date(item.meeting_date);
    const headerDateString = format(dateObj, "MM-dd-yyyy 'at' KK:mm aaa");
    return `${headerDateString}${meetingType ? ':' : ''}`;
  }, [item, meetingType]);

  return (
    <View
      style={{
        flexDirection: 'row',
        paddingTop: 16,
        paddingBottom: 16,
        justifyContent: 'space-between',
        alignItems: 'center',
      }}
    >
      <Accordion.Icon
        color={'black'}
        style={{
          //@ts-ignore
          cursor: 'pointer',
        }}
      />
      <Text fontSize={'xl'} fontWeight={'normal'}>
        {' '}
        {formattedDate}
      </Text>

      {item.meeting_type && !!item.notes_url && (
        <Link
          isExternal
          ml={1}
          zIndex={5}
          href={item.notes_url}
          _text={{
            fontSize: 'xs',
            _light: {
              color: 'primary.600',
            },
            color: 'primary.600',
            textTransform: 'none',
          }}
          _hover={{
            _text: {
              _light: {
                color: 'primary.700',
              },
              color: 'primary.700',
            },
          }}
          onPress={(evt) => {
            evt.stopPropagation();
          }}
        >
          {meetingType}
        </Link>
      )}

      {item.meeting_type && !item.notes_url && (
        <Text style={{ fontWeight: '600' }}> {meetingType}</Text>
      )}

      {isExpanded && (
        <IconButton
          onClick={(evt) => {
            evt.stopPropagation();
            onEdit();
          }}
        >
          <PencilIcon />
        </IconButton>
      )}
      {!item.id && (
        <Button
          onPress={onRemove}
          leftIcon={
            <MinusIcon
              name="cog-outline"
              as="Ionicons"
              color="red.500"
              size={3}
            />
          }
          type="button"
          variant={'outline'}
          w={'104px'}
          minH={'24px'}
          ml={3}
          borderColor={'red.500'}
          h={'32px'}
          rounded={3}
          _hover={{
            bg: 'red.200',
          }}
          _focus={{
            bg: 'transparent',
          }}
          _pressed={{
            bg: 'transparent',
          }}
        >
          <Text color={'red.500'} fontSize={'md'} fontWeight={'semibold'}>
            Remove
          </Text>
        </Button>
      )}
    </View>
  );
};
